<template>
  <div class="row">
    <div class="col-12" style="height: 100%">
      <div class="table-wrapper">
        <div class="buttons-wrapper">
          <b-button variant="primary" size="sm" v-for="o in operationalArea" :key="o.id" @click="goTo(o.id)">
            {{ o.name | i18n }}
          </b-button>
          <!-- <b-button variant="primary" size="sm" @click="goTo('power-plant')">
            {{ 'Power Plant' | i18n }}
          </b-button> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../../../api';

export default {
  title: 'Choose shift plant',
  data() {
    return {
      operationalArea: [],
    };
  },
  async created() {
    this.operationalArea = await api.operationalArea.get();
  },
  methods: {
    goTo(id) {
      this.$router.push({ name: 'shift-plant', params: { id } });
    },
  },
};
</script>

<style lang="scss" scoped>
.buttons-wrapper {
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 135px);
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  flex-direction: column;
}
.buttons-wrapper button {
  min-width: 150px;
  margin: 10px 0;
}

.main-content {
  width: 100%;
  min-height: calc(100vh - 120px);
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
